import "./About.css";
import profile from "./Images/Profile.jpeg";
export const About = () => {
  //     window.addEventListener("scroll",function(){
  // const up=this.document.querySelector("a.bottom-top")
  //         up.classList.toggle("active",this.window.scrollY>0)
  //     })
  return (
    <div id="about">
      <div className="about component__space">
        <div className="container">
          <div className="row">
            <div className="col__2">
              <img className="about__img" src={profile} />
            </div>
            <div className="col__2">
              <h1 className="about__heading align__item__center">About Me</h1>
              <div className="about__meta">
                <p className="about__text p__color">
                  Hi folks, my name is<span> Bhavani Dasari </span>and I am a{" "}
                  <span>Full Stack Web Developer</span>.
                  <br />I have learnt Web Designing from Masai School. I am
                  passionate about creating websites and building digital
                  products.I believe in enhancing my knowledge by solving
                  critical problems. I enjoy working on challengeing projects
                  that test my knowledge and skillset and in spire me to give my
                  best to arrive at a viable solution.
                  {/* I have been specializing in web design. 
                  I am passionated about creating websites and building digital things.I enhance my knowledge day-to-day to solve critical things. I love to work on the projects that tests my knowledge and skills which are challenging. */}
                  {/* I love creating websites.Along with them I am passionated
                  towards solving DSA and Alogrithms.In my free time, i like to
                  solve problems on LeetCode and HackerRank. */}
                  <br />
                </p>
                <div className="about__button d__flex align__items__center justify__content__center">
                  <a
                    href="https://drive.google.com/file/d/17E4_Id7uewdhf8voyA5jB9r7Y2HcbUWE/view?usp=sharing"
                    target="_blank"
                  >
                    <button className="about btn pointer">RESUME</button>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <div className="up__to__top__btn">
            <a href="#" className="bottom__top">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-up" viewBox="0 0 16 16">
  <path fill-rule="evenodd" d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708l6-6z"/>
</svg>
          </a>
        </div> */}
      </div>
    </div>
  );
};
